import { sessionStorage } from '../assets/js/storage'
const state = {
  user:null,
  token:null,
  mobilePhone:null,
  userId:null,
  inviteCode:null
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js